"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brisighella": {
    "acdd2511": [{
      "hkey": "fbbf173f",
      "slug": "brisighella",
      "name": "Brisighella",
      "primary": true,
      "skipSearch": false
    }],
    "montefortino": [{
      "hkey": "fbbf173f",
      "slug": "brisighella",
      "name": "Brisighella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3df5d038": [{
      "hkey": "fbbf173f",
      "slug": "brisighella",
      "name": "Brisighella",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-nono": [{
      "hkey": "fbbf173f",
      "slug": "brisighella",
      "name": "Brisighella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;